import Timer from "/components/core/DateTimer";

export default function About({ isEnded }) {
  return (
    <section className="about">
      <div className="wrapper">
        <h1 className="sr-only">Funtico Sports - Road to Word CUP 2026</h1>
        <div className="wrapper-logo">
          <img src="logo-back.png" alt="" className="logo" />
        </div>

        <div className="wrapper-text">
          <div className="wrapper-text-content ">
            {/* {isEnded ? <ContentEnded /> : <ContentActvie />} */}
            <ContentActvie />
            {!isEnded && <Timer playButton={false} />}
          </div>
        </div>
      </div>
    </section>
  );
}

function ContentActvie() {
  return (
    <div className="font-20 wrapper-text-top shadow">
      <p>
        <strong>
          The fun, competitive & fair-play home for all sports communities.
        </strong>
      </p>

      <p>
        Your journey to major sports events, tickets, RTBs <br />
        or exclusive rewards starts here!
      </p>
      <br />
    </div>
  );
}

function ContentEnded() {
  return (
    <>
      <div className="font-20 wrapper-text-top shadow">
        <p>
          <strong>
            The fun, competitive & fair-play home for all sports communities.
          </strong>
        </p>
        <p>
          <strong style={{ fontFamily: "var(--fixel_sbd)" }}>
            Your journey to major sports events, tickets, RTBs <br />
            or exclusive rewards starts here!{" "}
          </strong>
        </p>
      </div>
      <div className="next-event-info df fd-c ai-c text-center">
        <p className="kanit-bold title">NEXT EVENT:</p>
        <p className="kanit-bold soon">COMING SOON</p>
      </div>
    </>
  );
}
